import { admin2 } from './instance'

const baseUrl = (shopId) => `/${shopId}/ticketBox`

/**
 * 取得票匣列表
 * @param {Object} params
 * @param {string} params.shopId - 店家 ID
 * @param {string} [params.name] - 票匣名稱（模糊搜尋）
 * @param {number} [params.start=0] - 分頁起始
 * @param {number} [params.limit=10] - 每頁筆數
 * @returns {Promise} 票匣列表
 */
export const GetTicketBox = async ({ shopId, name, start, limit }) => {
  return await admin2({
    method: 'get',
    url: baseUrl(shopId),
    params: {
      name,
      start,
      limit,
    },
  })
}

/**
 * 取得票匣總數
 * @param {Object} params
 * @param {string} params.shopId - 店家 ID
 * @param {string} [params.name] - 票匣名稱（模糊搜尋）
 * @returns {Promise} 票匣總數
 */
export const GetTicketBoxCount = async ({ shopId, name }) => {
  return await admin2({
    method: 'get',
    url: `${baseUrl(shopId)}/count`,
    params: {
      name,
    },
  })
}

/**
 * 取得單一票匣
 * @param {Object} params
 * @param {string} params.shopId - 店家 ID
 * @param {string} params.id - 票匣 ID
 * @returns {Promise} 票匣詳情
 */
export const FindTicketBox = async ({ shopId, id }) => {
  return await admin2({
    method: 'get',
    url: `${baseUrl(shopId)}/${id}`,
  })
}

/**
 * 新增票匣
 * @param {Object} params
 * @param {string} params.shopId - 店家 ID
 * @param {string} params.name - 票匣名稱（必填）
 * @param {string} [params.notice] - 注意事項
 * @param {boolean} [params.isClientUsageAllowed] - 是否允許會員自行核銷
 * @param {string} [params.imageId] - 圖片 ID
 * @param {string} [params.expType] - 到期類型：expAt / expDay / endOfPeriod
 * @param {number} [params.expDay] - 領取後可使用天數（expType=expDay 時必填）
 * @param {string} [params.expAt] - 特定截止日期 ISO datetime（expType=expAt 時必填）
 * @param {string} [params.endOfPeriodUnit] - 當期結束單位：day/week/month/quarter/year（expType=endOfPeriod 時必填）
 * @returns {Promise} 新增結果
 */
export const CreateTicketBox = async ({
  shopId,
  name,
  notice,
  isClientUsageAllowed,
  imageId,
  expType,
  expDay,
  expAt,
  endOfPeriodUnit,
}) => {
  return await admin2({
    method: 'post',
    url: baseUrl(shopId),
    data: {
      name,
      notice,
      isClientUsageAllowed,
      imageId,
      expType,
      expDay,
      expAt,
      endOfPeriodUnit,
    },
  })
}

/**
 * 更新票匣（僅允許更新 name / notice / isClientUsageAllowed / imageId）
 * @param {Object} params
 * @param {string} params.shopId - 店家 ID
 * @param {string} params.id - 票匣 ID
 * @param {string} [params.name] - 票匣名稱
 * @param {string} [params.notice] - 注意事項
 * @param {boolean} [params.isClientUsageAllowed] - 是否允許會員自行核銷
 * @param {string} [params.imageId] - 圖片 ID
 * @returns {Promise} 更新結果
 */
export const UpdateTicketBox = async ({
  shopId,
  id,
  name,
  notice,
  isClientUsageAllowed,
  imageId,
}) => {
  return await admin2({
    method: 'put',
    url: `${baseUrl(shopId)}/${id}`,
    data: {
      name,
      notice,
      isClientUsageAllowed,
      imageId,
    },
  })
}

/**
 * 刪除票匣（軟刪除）
 * @param {Object} params
 * @param {string} params.shopId - 店家 ID
 * @param {string} params.id - 票匣 ID
 * @returns {Promise} 刪除結果
 */
export const DeleteTicketBox = async ({ shopId, id }) => {
  return await admin2({
    method: 'delete',
    url: `${baseUrl(shopId)}/${id}`,
  })
}
